import { render, staticRenderFns } from "./subjectselector.vue?vue&type=template&id=1340f044&scoped=true&"
import script from "./subjectselector.vue?vue&type=script&lang=js&"
export * from "./subjectselector.vue?vue&type=script&lang=js&"
import style0 from "./subjectselector.vue?vue&type=style&index=0&id=1340f044&prod&scoped=true&lang=scss&"
import style1 from "./subjectselector.vue?vue&type=style&index=1&id=1340f044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340f044",
  null
  
)

export default component.exports